var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInactiveCost(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "#ffffff00",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#CCC",
    strokeOpacity: 0.8,
    d: "M14.1666 13.3332v.0006c.0025 2.7181.9963 5.342 2.7951 7.3797 1.701 1.9271 4.0115 3.2048 6.5383 3.6253v2.9038l-2.4235-1.0357-.1969-.0842-.1968.0845-2.9095 1.2487-2.9095-1.2487-.1972-.0846-.1972.0846-2.9094 1.2487-2.90949-1.2487-.19678-.0845-.1969.0842-2.42352 1.0357V5.33333c0-.22101.0878-.43297.24408-.58925.15628-.15628.36824-.24408.58926-.24408H18.5049c-1.1179.86395-2.0659 1.93549-2.7891 3.1612-1.0138 1.71834-1.5487 3.6769-1.5492 5.672Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#8E8E98",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M21.3333 17.3334h3.3333c.5305 0 1.0392-.2107 1.4143-.5858.375-.3751.5857-.8838.5857-1.4142 0-.5305-.2107-1.0392-.5857-1.4142-.3751-.3751-.8838-.5858-1.4143-.5858h-1.3333c-.5304 0-1.0391-.2107-1.4142-.5858s-.5858-.8838-.5858-1.4142c0-.5305.2107-1.0392.5858-1.41424.3751-.37507.8838-.58579 1.4142-.58579h3.3333"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#8E8E98",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.8,
    d: "M24 9.33333V8m0 10.6667v-1.3334M16 20h-5.3333M16 14.6667h-5.3333"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#CCC",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeOpacity: 0.8,
    d: "M20 4H6.66665c-.35363 0-.69276.14048-.94281.39052-.25005.25005-.39053.58919-.39053.94281V28l3.12-1.3333L11.56 28l3.1066-1.3333L17.7733 28l3.1067-1.3333L24 28v-4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveCost);
export default __webpack_public_path__ + "static/media/InactiveCost.381c213ebfd06bc2255a0fbac6e46b54.svg";
export { ForwardRef as ReactComponent };